import React, { useEffect, useState } from "react";
import {
  ProfileContainer,
  ProfileCard,
  ProfileHeader,
  ProfileAvatarWrapper,
  ProfileName,
  ProfileRole,
  ProfileContent,
  InfoGroup,
  InfoLabel,
  InfoValue,
  ProfileFooter,
  CalendarButton
} from "./styles";
import { useToasts } from "react-toast-notifications";
import { useSelector } from "react-redux";
import PersonIcon from "@material-ui/icons/Person";
import EventIcon from "@material-ui/icons/Event";

export const Usuario = () => {
  const { addToast } = useToasts();
  const usuario = useSelector((state) => state.usuario);
  const empresa = useSelector((state) => state.empresa);
  const [isAuthorizeButtonDisabled, setIsAuthorizeButtonDisabled] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  function handleAuthorize() {
    setIsAuthorizeButtonDisabled(true);
    const additionalParams = {
      empresaId: empresa.id
    };

    const params = new URLSearchParams(additionalParams);
    const authorizeUrl = `${API_URL}/api/v1/calendar/authorize?${params.toString()}`;
    window.location.href = authorizeUrl;
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authSuccess = urlParams.get('authSuccess');

    if (authSuccess) {
      addToast("Google Calendar vinculado satisfactoriamente", {
        appearance: "success",
      });
      setIsAuthorizeButtonDisabled(false);
    }
  }, [addToast]);

  if (usuario.loading || usuario.loading === undefined)
    return <ProfileContainer>...procesando</ProfileContainer>;

  if (usuario.error)
    return <ProfileContainer>{`Hubo un error ${usuario.error}`}</ProfileContainer>;

  const userData = usuario.data || {};

  return (
    <ProfileContainer>
      <ProfileCard>
        <ProfileHeader>
          <ProfileAvatarWrapper>
            {userData.foto || userData.firma ? (
              <img src={userData.foto || userData.firma} alt={userData.nombres} />
            ) : (
              <PersonIcon />
            )}
          </ProfileAvatarWrapper>
          <ProfileName>{userData.nombres || "Usuario"}</ProfileName>
          <ProfileRole>{userData.cargo || "Especialista"}</ProfileRole>
        </ProfileHeader>

        <ProfileContent>
          <InfoGroup>
            <InfoLabel>Correo Electrónico</InfoLabel>
            <InfoValue>{userData.email || "No registrado"}</InfoValue>
          </InfoGroup>

          <InfoGroup>
            <InfoLabel>Perfil de Acceso</InfoLabel>
            <InfoValue>{userData.perfil || "Usuario"}</InfoValue>
          </InfoGroup>

          <InfoGroup>
            <InfoLabel>COP (Colegiatura)</InfoLabel>
            <InfoValue>{userData.cop || "N/A"}</InfoValue>
          </InfoGroup>

          <InfoGroup>
            <InfoLabel>Empresa / Consultorio</InfoLabel>
            <InfoValue>{empresa.razonSocial || "Mi Consultorio"}</InfoValue>
          </InfoGroup>
        </ProfileContent>


      </ProfileCard>
    </ProfileContainer>
  );
};
